import { DataTable } from 'primereact/datatable';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import { Column } from 'primereact/column';
import React, { useState } from 'react';
import CallToActionButton from '../../../component/call-to-action-button/call-to-action-button';
import { Dialog } from 'primereact/dialog';
import { AddPaymentServiceDialog } from './componenets/add-payment-service-dialog';
import globalPaymentServices from '../../../stores/global-payment-services';
import { observer } from 'mobx-react-lite';
import { Button } from 'primereact/button';
import { PaymentServiceWithVersionsResponseType } from '../../../api/types/payments/payment-template';
import { EditTextDialog } from '../../settings/componenets/edit-entity-name-dialog/edit-text-dialog';
import { deletePaymentServiceOperation } from './operations/delete-payment-service.operation';
import { editPaymentServiceNameOperation } from './operations/edit-payment-service-name.operation';

export const PaymentPageTabs = observer(() => {
  const [selectedUsers, setSelectedUsers] = useState<UserSummaryType[]>([]);
  const [addPaymentDialog, setAddPaymentDialog] = useState(false);
  const [editPaymentService, setEditPaymentService] =
    useState<PaymentServiceWithVersionsResponseType | null>(null);
  const [loading, setLoading] = useState(false);
  const [deletePaymentServiceId, setDeletePaymentServiceId] = useState<
    number | null
  >(null);

  const closeDialog = () => {
    setAddPaymentDialog(false);
  };

  const handleEditPaymentService = (
    paymentService: PaymentServiceWithVersionsResponseType,
  ) => {
    setEditPaymentService(paymentService);
  };

  const handleSavePaymentService = async (id: number, newName: string) => {
    await editPaymentServiceNameOperation(id, newName, setLoading);
    setEditPaymentService(null);
  };

  const handleDeletePaymentService = async (paymentServiceId: number) => {
    await deletePaymentServiceOperation(
      paymentServiceId,
      setDeletePaymentServiceId,
    );
  };

  return (
    <div>
      <EditTextDialog
        id={editPaymentService?.id}
        value={editPaymentService?.paymentServiceName}
        title="עריכת שרות תשלום"
        label="שם שרות התשלום"
        loading={loading}
        onSave={handleSavePaymentService}
        onHide={() => setEditPaymentService(null)}
      />

      <div
        style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
      >
        <CallToActionButton
          text={'הוספה'}
          onClick={() => {
            setAddPaymentDialog(true);
          }}
        />
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={globalPaymentServices.services}
        selection={[]}
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        {/*<Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />*/}
        <Column
          style={{ textAlign: 'right' }}
          field="paymentServiceName"
          header="שם שרות"
        />
        <Column field="lastName" header="" style={{ textAlign: 'right' }} />
        <Column
          body={(data, options) => (
            <div>{JSON.stringify(data.versions[0].price)}</div>
          )}
          header="מחיר"
          style={{ textAlign: 'right' }}
        />
        <Column
          field="createdByName"
          header="נוצר ע״י"
          style={{ textAlign: 'right' }}
        />
        <Column
          field="createdAt"
          header="תאריך יצירה"
          style={{ textAlign: 'right' }}
          body={(rowData) =>
            rowData.createdAt
              ? new Date(rowData.createdAt).toLocaleDateString('he-IL') // Format date to 'dd/mm/yyyy' for Hebrew locale
              : ''
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: PaymentServiceWithVersionsResponseType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת שרות תשלום'}
                onClick={() => handleEditPaymentService(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת שרות תשלום'}
                loading={deletePaymentServiceId === data.id}
                disabled={deletePaymentServiceId !== null}
                onClick={() => handleDeletePaymentService(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת שרות תשלומים"
        visible={addPaymentDialog}
        style={{
          width: '800px',
          height: '70vh',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setAddPaymentDialog(false);
        }}
      >
        <AddPaymentServiceDialog closeDialog={closeDialog} />
      </Dialog>
    </div>
  );
});
